module.exports = "/_next/static/images/es-c3853709f676abcc9c50ce691004cdb5.svg";